export enum ModalMode {
    Info = 'INFO',
    Edit = 'MODIFY',
    Create = 'CREATE',
    ChangePhase = 'CHANGEPHASE',
    Remove = 'REMOVE',
    Link = 'LINK',
    PortaUnAmico = 'PORTAUNAMICO'
}



// WEBPACK FOOTER //
// ./src/app/helpers/modalMode.enum.ts